const CheckboxGroup = ({id, label, ...props}) => (
    <label className="checkbox-group" htmlFor={id}>
        <input id={id} type="checkbox" {...props} />
        <span>{label}</span>
    </label>
);

export default CheckboxGroup;
